import React, { useState } from 'react'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import { Field } from 'redux-form'
import { IconButton, Collapse, Card, CardHeader, CardContent, Tooltip } from '@material-ui/core'
import { ExpandMore, ExpandLess, Delete, Edit } from '@material-ui/icons'
import { Button } from 'semantic-ui-react'
import ReactTable from 'react-table'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import ContactModal from './ContactModal'
import { VendorContactContainer, ActionButtonContainer } from './styled'

const BankGuaranteeInformation = (props) => {
  const { valueForm, change, isDisplay=false, editMode=false } = props
  const [showVendorContact, setShowVendorContact] = useState(true)
  const [showContactModal, setShowContactModal] = useState(false)
  const [contactData, setContactData] = useState(undefined)
  var contacts = valueForm.vendorContacts || []

  const editableForm = () => {
    if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
      return !isDisplay && (valueForm.sn !== undefined && valueForm.sn !== null && valueForm.sn !== '')
    } else {
      return !isDisplay
    }
  }

  const onSubmitVendorContact = (data, isNew, oldData) => {
    if (isNew) {
      change('vendorContacts', [...contacts, data])
    } else {
      const index = contacts.findIndex(u => u.email === oldData.email)
      change(`vendorContacts[${index}]`, data)
    }
  }

  const columnUser = (props) => {
    const { withActions, showContactModal, onDeleteContact } = props
  
    return ([
      {
        Header: 'Action',
        accessor: '',
        show: withActions,
        width: 100,
        Cell: row => (
          <ActionButtonContainer>
            <Tooltip title='Edit'>
              <IconButton onClick={() => showContactModal(row.index)}>
                <Edit />
              </IconButton>
            </Tooltip>
            <Tooltip title='Remove'>
              <IconButton onClick={() => onDeleteContact(row.index)}>
                <Delete />
              </IconButton>
            </Tooltip>
          </ActionButtonContainer>
        )
      }, {
        Header: 'Firstname',
        accessor: 'firstname',
      }, {
        Header: 'Lastname',
        accessor: 'lastname',
      }, {
        Header: 'Email',
        accessor: 'email',
      }, {
        Header: 'Mobile',
        accessor: 'mobile',
        width: 100,
      }, {
        Header: 'Telephone',
        accessor: 'telephone',
        width: 100,
      }, {
        Header: 'Extension',
        accessor: 'extension',
        width: 80,
      }
    ])
  }

  const showModalEditContact = (index) => {
    setContactData(contacts[index])
    setShowContactModal(true)
  }

  const onDeleteContact = (userIndex) => {
    var clone = [...(valueForm.vendorContacts || [])]
    clone.splice(userIndex, 1)
    change('vendorContacts', [...clone])
  }

  return (
    <Card style={{ marginTop: '10px' }}>
      <CardHeader 
        title='Vendor Contact'
        action={
          <IconButton aria-label='Expand' onClick={() => setShowVendorContact(!showVendorContact) }>
            {showVendorContact ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        }
      />
      <Collapse in={showVendorContact}>
        <CardContent style={{ paddingTop: '0px' }}>
          <VendorContactContainer>
            <div className='rowFields'>
              <Field 
                name='vendorContactsErrorMessage'
                label='' 
                type={type.labelOnly} 
                component={FieldInput} 
              />
            </div>
            {
              editableForm() || editMode ? 
              <div className='rowFields'>
                <Button 
                  type='button' 
                  color='blue' 
                  content='Add Name'
                  icon='plus'
                  labelPosition='right'
                  onClick={() => setShowContactModal(true)} />
                <Field type={type.empty} component={FieldInput} />
              </div> : null
            }
            {
              contacts.length === 0 ? null :
              <ReactTable
                data={contacts}
                columns={
                  columnUser({ 
                    withActions: editableForm() || editMode,
                    showContactModal: showModalEditContact, 
                    onDeleteContact: onDeleteContact 
                  })}
                sortable={false}
                pageSize={contacts.length}
                defaultPageSize={contacts.length}
                className='-striped -highlight'
                style={{ 
                  marginTop: (editableForm() || editMode) ? '10px' : '0px'
                 }}
                showPagination={false}
              />
            }
          </VendorContactContainer>
        </CardContent>
      </Collapse>
      {
        showContactModal ? 
          <ContactModal 
            contactData={contactData}
            listContact={contacts}
            clearContactData={() => setContactData(undefined)}
            closeModal={() => setShowContactModal(false)} 
            onSubmitContact={onSubmitVendorContact}
          /> : null
      }
    </Card>
  )
}

const mapStateToProps = (state) => {
  return ({
    valueForm: getFormValues('formBankGuarantee')(state) || {}
  })
}
  
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(BankGuaranteeInformation)